import { render, staticRenderFns } from "./UserD.vue?vue&type=template&id=eb8db820"
import script from "./UserD.vue?vue&type=script&lang=js"
export * from "./UserD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports